import { useInfiniteQuery } from '@tanstack/react-query';

import type { GetMeetingsParams } from '#meeting/meetingService';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetGroupMeetingsInfinite(params: GetMeetingsParams) {
  return useInfiniteQuery({
    queryKey: [GroupKey.GROUP_MEETINGS_INFINITE, params],
    queryFn: ({ pageParam }) => {
      return GroupService.getGroupMeetings(pageParam).then((response) => response.data);
    },
    initialPageParam: {
      page: 0,
      pageSize: 20,
      name: undefined,
      sortOrder: 'ASC' as const,
      ...params,
    },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });
}
